module.exports = "<vb-generic-selection-input\r\n  inputId=\"account-input\"\r\n  label=\"Buchungskonto\"\r\n  [control]=\"control\"\r\n  [optional]=\"false\"\r\n  [items]=\"accounts$ | async\"\r\n  [selectedItem]=\"item\"\r\n  (itemChanged)=\"onItemChangedEvent($event)\">\r\n</vb-generic-selection-input>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/components/account-selection/account-selection.component.html
// module id = ./src/app/crm/components/account-selection/account-selection.component.html
// module chunks = main